import React from 'react';

// Utils
import cn from 'classnames';

const defaultProps = {
  code: 'ua',
};

const CountryFlag = ({ code, space, style }) => (
  <span
    className={cn('flag-icon', `flag-icon-${code}`, 'flag-icon-squared', {
      'flag-icon_space': space,
    })}
    style={style}
  />
);

CountryFlag.defaultProps = defaultProps;

export default CountryFlag;
